/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DetailedBudgetDto } from '../../models/detailed-budget-dto';

export interface GetDetailedBudget$Params {
  id: string;
}

export function getDetailedBudget(http: HttpClient, rootUrl: string, params: GetDetailedBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedBudgetDto>> {
  const rb = new RequestBuilder(rootUrl, getDetailedBudget.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DetailedBudgetDto>;
    })
  );
}

getDetailedBudget.PATH = '/v0/budgets/{id}/details';
